import React, { useState } from 'react';
import InviteModal from './InviteModal';

const InviteButton = ({ isAuthenticated = false, onSignIn, roomId }) => {
  const [showModal, setShowModal] = useState(false);

  const handleInviteClick = () => {
    setShowModal(true);
  };

  return (
    <>
      <button
        onClick={handleInviteClick}
        className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm font-medium transition-colors"
      >
        Invite Friends
      </button>
      
      {showModal && (
        <InviteModal 
          onClose={() => setShowModal(false)} 
          isAuthenticated={isAuthenticated}
          onSignIn={onSignIn}
          roomId={roomId}
        />
      )}
    </>
  );
};

export default InviteButton;